import { render, staticRenderFns } from "./shuzi.vue?vue&type=template&id=d5a9ecaa&scoped=true&"
import script from "./shuzi.vue?vue&type=script&lang=js&"
export * from "./shuzi.vue?vue&type=script&lang=js&"
import style0 from "./shuzi.vue?vue&type=style&index=0&id=d5a9ecaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a9ecaa",
  null
  
)

export default component.exports